export default __webpack_public_path__ + "static/media/dolor_toracico_actualizacion2015.7a303592.pdf";